import { Button, ButtonVariant } from '@creditornot/cb-button';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cb-modal';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import WoltModal from 'common/components/WoltModal';

type Props = {
  className?: string;
  header: React.ReactNode;
  description?: React.ReactNode;
  cancelText?: React.ReactNode;
  confirmText?: React.ReactNode;
  cancelVariant?: ButtonVariant;
  confirmVariant?: ButtonVariant;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  loading?: boolean;
  disabled?: boolean;
};

const StyledWoltModal = styled(WoltModal)`
  width: 400px;
  background: ${cssThemedValue('surfaceMain')};
  border-radius: 8px;
`;

const StyledFooter = styled(ModalFooter)`
  justify-content: flex-end;
`;

const ConfirmButton = styled(Button).attrs({ size: 'small' })``;

const CancelButton = styled(Button).attrs({ size: 'small' })`
  margin-inline-end: 16px;
`;

const ConfirmModal = ({
  className,
  header,
  description = <FormattedMessage id="dropdown.areYouSure" />,
  cancelText = <FormattedMessage id="dropdown.confirmNo" />,
  confirmText = <FormattedMessage id="dropdown.confirmYes" />,
  cancelVariant = 'lightBlue',
  confirmVariant = 'blue',
  onCancel,
  onConfirm,
  open,
  loading,
  disabled,
}: Props) => {
  useEffect(() => {
    if (open) {
      const handleKeyDown = (event: KeyboardEvent) => {
        event.preventDefault();
        if (event.key === 'Enter') {
          onConfirm();
        }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => window.removeEventListener('keydown', handleKeyDown);
    }
    return;
  }, [onConfirm, open]);

  return (
    <StyledWoltModal className={className} isOpen={open} onRequestClose={onCancel}>
      <ModalHeader onCloseClick={onCancel}>{header}</ModalHeader>
      <ModalContent>{description}</ModalContent>
      <StyledFooter>
        <CancelButton onClick={onCancel} variant={cancelVariant}>
          {cancelText}
        </CancelButton>
        <ConfirmButton onClick={onConfirm} loading={loading} disabled={disabled} variant={confirmVariant}>
          {confirmText}
        </ConfirmButton>
      </StyledFooter>
    </StyledWoltModal>
  );
};

export default ConfirmModal;
